import React from 'react';
import cn from 'classnames';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import FsSubtitleBold from 'ui-elements/typography/FsSubtitleBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import { green, grey, purple } from 'globals/colors';
import { TypographyAllProps } from 'globals/types';

export const WrapperBox = withStyles(() => ({
  root: {},
}))(Box);

interface OptionNameProps extends TypographyAllProps {
  isActive?: boolean;
}

export const OptionName = withStyles(({ spacing, palette, transitions }) => ({
  root: {
    marginBottom: spacing(2),
    fontWeight: 700,
    color: grey.V3,
    transition: transitions.create(['color']),
    '&.active': {
      color: palette.common.black,
    },
  },
}))(({ isActive, ...otherProps }: OptionNameProps) => (
  <FsSubtitleBold {...otherProps} className={cn({ active: isActive })} />
));

interface SpecialProps extends TypographyAllProps {
  isActive?: boolean;
}

export const Special = withStyles(({ transitions }) => ({
  root: {
    fontWeight: 300,
    color: grey.V3,
    transition: transitions.create(['color']),
    '&.active': {
      color: purple.BRAND,
    },
  },
}))(({ isActive, ...otherProps }: SpecialProps) => (
  <FsSubtitleBold
    {...otherProps}
    component="span"
    className={cn({ active: isActive })}
  />
));

export const Description = withStyles(() => ({
  root: {},
}))(FsBodySmall);

interface TabIconProps extends BoxProps {
  isActive?: boolean;
  isHover?: boolean;
}

export const TabIcon = withStyles(({ spacing, palette }) => ({
  root: {
    display: 'block',
    width: spacing(3),
    height: spacing(3),
    border: `1px solid ${grey.V4}`,
    borderRadius: '50%',
    background: palette.common.white,
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: spacing(2),
      height: spacing(2),
      borderRadius: '50%',
      background: green.MAIN,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) scale(0)',
      transition: `transform .3s ease-in-out`,
    },
    '&.hover': {
      '&:after': {
        transform: 'translate(-50%, -50%) scale(0.5)',
      },
    },
    '&.active': {
      '&:after': {
        transform: 'translate(-50%, -50%) scale(1) !important',
      },
    },
  },
}))(({ isActive, isHover, ...otherProps }: TabIconProps) => (
  <Box {...otherProps} className={cn({ active: isActive, hover: isHover })} />
));
